document.querySelectorAll('[data-copy]').forEach(element => {
    element.addEventListener('click', () => {
        navigator.clipboard?.writeText(element.dataset.copy).then(() => {}, () => {});
    });
});

document.querySelectorAll('[data-copy-target]').forEach(element => {
    element.addEventListener('click', () => {
        navigator.clipboard?.writeText(document.querySelector('#' + element.dataset.copyTarget)?.value).then(() => {}, () => {});
    });
});
